module.exports = __webpack_public_path__ + "img/HTCC-CCS811B.de6b92e6.jpg";